export const titleWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
};
